import { setup } from '@/setup.ts';
import { router } from '@/router/index.ts';

import App from '@/views/App.vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { useAuthStore } from '@/stores/authentication.ts';
import { useErrorsStore } from '@/stores/errors.ts';
import { useVersioningStore } from '@/stores/versioning.ts';
import axios, { type AxiosResponse, type AxiosError } from 'axios';
import { usePreferencesStore } from "@/stores/preferences.ts";

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
interface LaravelError {
  errors:string[];
}

// Handle common errors inbound
axios.interceptors.response.use((response:AxiosResponse) => { return response; }, (error: AxiosError) => {
  if (error.response === undefined) return Promise.reject(error);
  if (error.response.status == 401) {
    // Handle unauthorised by force logging out our user and then putting them to the login page
    const authStore = useAuthStore();
    authStore.checkAuthState();
  }

  if (error.response.status == 500) {
    const errorsStore = useErrorsStore();
    errorsStore.setErrors([
      'An error has occurred, if this persists please contact the system administrator.'
    ]);
  }

  // Check if we have generic errors and fill the error state and module
  if ((error.response.data as LaravelError).errors) {
    const errorsStore = useErrorsStore();
    errorsStore.setErrors((error.response.data as LaravelError).errors);
  }

  return Promise.reject(error);
});

router.beforeEach((to, from, next) => {
  document.title = to.name as string;
  const versionStore = useVersioningStore();
  void versionStore.checkVersion();
  next();
  if (versionStore.updateAvailable) {
    versionStore.updateSite();
  }
});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
const app = setup(App, router, pinia);
app.mount("#app");

{
  const vers = useVersioningStore();
  vers.checkInternalVersions();
  vers.bootVersion();
  const prefs = usePreferencesStore();
  prefs.updateTimezone(prefs.timezone == null ? false : prefs.timezone.useBrowserTime);
}


